import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { push } from 'react-router-redux';
import { isEmpty, identity } from 'ramda';

import {
  setHistoricalSearchValues,
  setByAirlineSecondaryAction,
} from '../../../redux/Single/actions';
import FSDatePicker from '../../../../../shared/components/FSDatePicker/FSDatePicker';
import flexErrors from '../../../../../src/constants/flex-errors';
import AirlineSelect from '../../../../../src/components/lib/AirlineSelect';
import AirportSelect from '../../../../../src/components/lib/AirportSelect';
import FSFlatButton from '../../../../../src/components/lib/FSFlatButton';
import { dateFormatString } from '../../../../../src/lib/date-time-format';
import componentBase from '../../../../../src/lib/component-base';

@componentBase('HistoricalByAirportSearch')
export default class HistoricalByAirportSearch extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    arrivalAirport: PropTypes.object,
    byAirportAirline: PropTypes.object,
    departureAirport: PropTypes.object,
    airportSearchDepartureDate: PropTypes.object,
    handleAirlineByRouteChange: PropTypes.func,
    handleAirportArrivalChange: PropTypes.func,
    handleAirportDepartureChange: PropTypes.func,
    handleDepartureDateChange: PropTypes.func,
    user: PropTypes.object,
    byAirlineSecondaryAction: PropTypes.bool,
  }

  constructor(props, context) {
    super(props, context);
    this.reportButtonPress = this.reportButtonPress.bind(this);
    this.dateChangeHandler = this.dateChangeHandler.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentWillMount() {
    this.state = {
      errorText: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { byAirlineSecondaryAction, dispatch } = nextProps;

    if (byAirlineSecondaryAction) {
      dispatch(setByAirlineSecondaryAction(false));
    }
  }

  onAirlineChange = (option) => {
    this.props.handleAirlineByRouteChange(option);
  }

  onDelete = (action, value) => {
    this.props.dispatch(action(value));
  }

  onInputChange = (option, stateKey) => {
    const newState = {};
    newState[stateKey] = option && option.value;
    this.props.dispatch(setHistoricalSearchValues(newState));
  }

  /* eslint-disable no-underscore-dangle */
  getAirLinePortCodes = airLinePort => (
    airLinePort &&
    airLinePort.value &&
    airLinePort.value._source &&
    airLinePort.value._source.fs
  );

  handleAirportDepartureChange = (option) => {
    this.props.handleAirportDepartureChange(option);
  }

  handleAirportArrivalChange = (option) => {
    this.props.dispatch.handleAirportArrivalChange(option);
  }

  /* eslint-disable no-underscore-dangle */
  dateChangeHandler = (date) => {
    this.props.handleDepartureDateChange(date, 'airportSearch');
  }

  reportButtonPress = (label) => {
    this.context.reportButtonPress(label);
  }

  submit = (e) => {
    e && e.preventDefault();
    const url = this.buildUrl();

    if (this.validateAirportSearch() && url) {
      this.setState({ errorText: null }, () => {
        this.props.dispatch(push(url));
      });
    } else if (this.errorText) {
      this.setState({ errorText: this.errorText });
    }
  }

  validateAirportSearch = () => {
    const {
      departureAirport,
      arrivalAirport,
      airportSearchDepartureDate,
    } = this.props;
    this.errorText = null;

    if (!airportSearchDepartureDate.isValid()) {
      this.errorText = flexErrors('BAD_MOMENT');
    } else if (isEmpty(departureAirport) && isEmpty(arrivalAirport)) {
      this.errorText = flexErrors('HISTORICAL_AIRPORT_SEARCH_NO_INFORMATION_ENTERED');
    }

    return this.errorText === null;
  }

  buildUrl = () => {
    const {
      byAirportAirline,
      departureAirport,
      arrivalAirport,
      airportSearchDepartureDate,
    } = this.props;

    let path;
    const departureAirportCode = this.getAirLinePortCodes(departureAirport);
    const arrivalAirportCode = this.getAirLinePortCodes(arrivalAirport);
    const airportSearchDepartureDateFormatted = moment(airportSearchDepartureDate).format('YYYY/MM/DD');

    if (departureAirportCode && !arrivalAirportCode) {
      path = `/historical-flight/departing/${departureAirportCode}/${airportSearchDepartureDateFormatted}`;
    } else if (arrivalAirportCode && !departureAirportCode) {
      path = `/historical-flight/arriving/${arrivalAirportCode}/${airportSearchDepartureDateFormatted}`;
    } else if (departureAirportCode && arrivalAirportCode) {
      path = `/historical-flight/route/${departureAirportCode}/${arrivalAirportCode}/${airportSearchDepartureDateFormatted}`;
    }

    if (byAirportAirline) {
      const airlineCode = this.getAirLinePortCodes(byAirportAirline);
      path = `${path}/${airlineCode}`;
    }

    return path;
  };

  render = () => {
    const {
      byAirportAirline,
      arrivalAirport,
      departureAirport,
      airportSearchDepartureDate,
      byAirlineSecondaryAction,
    } = this.props;

    let error = '';
    if (this.state.errorText) {
      error = (
        <div className='search-error-text-block'>
          <p className='search-error-text'>{this.state.errorText}</p>
        </div>
      );
    }

    return (
      <form onSubmit={this.submit}>
        <section className='fs-search-card historical-airport row'>
          { error }
          <p className='search-title'>Search by Airport/Route</p>
          <div className='advanced-search-bar col-sm-6'>
            <p>Departure Airport</p>
            <div className='search-box'>
              <AirportSelect
                inputTitle='Departure Airport'
                name='departureAirport'
                onChange={(option, triggeredByEnter) =>
                  this.props.dispatch(setHistoricalSearchValues({ departureAirport: option }, triggeredByEnter, false))
                }
                airport={departureAirport}
                secondaryAction={
                  byAirlineSecondaryAction ?
                    this.submit : identity
                }
                onDelete={
                  () => (
                    this.onDelete(
                      setHistoricalSearchValues,
                      {
                        departureAirport: {},
                      },
                    )
                  )
                }
              />
            </div>
          </div>
          <div className='advanced-search-bar col-sm-6'>
            <p>Arrival Airport</p>
            <div className='search-box'>
              <AirportSelect
                inputTitle='Arrival Airport'
                name='arrivalAirport'
                onChange={(option, triggeredByEnter) =>
                  this.props.dispatch(setHistoricalSearchValues({ arrivalAirport: option }, triggeredByEnter, false))
                }
                airport={arrivalAirport}
                secondaryAction={
                  byAirlineSecondaryAction ?
                    this.submit : identity
                }
                onDelete={
                  () => (
                    this.onDelete(
                      setHistoricalSearchValues,
                      {
                        arrivalAirport: {},
                      },
                    )
                  )
                }
              />
            </div>
          </div>
          <div className='advanced-search-bar col-sm-6'>
            <p>Airline</p>
            <div className='search-box'>
              <AirlineSelect
                name='airline'
                airline={byAirportAirline}
                onChange={(option, triggeredByEnter) =>
                  this.props.dispatch(setHistoricalSearchValues({ byAirportAirline: option }, triggeredByEnter, false))
                }
                secondaryAction={
                  byAirlineSecondaryAction ?
                    this.submit : identity
                }
                onDelete={
                  () => (
                    this.onDelete(
                      setHistoricalSearchValues,
                      {
                        byAirportAirline,
                      },
                    )
                  )
                }
              />
            </div>
          </div>
          <div className='advanced-search-bar col-sm-6' style={{ position: 'relative' }}>
            <p>Date</p>
            <div className='search-box'>
              <FSDatePicker
                className='advanced-search-text-field full-width'
                style={{ width: '100%' }}
                key='airportSearchDepartureDate'
                locale='en'
                dateFormat={dateFormatString(this.props.user)}
                selected={airportSearchDepartureDate}
                maxDate={moment()}
                minDate={moment('20060207', 'YYYYMMDD')}
                onChange={this.dateChangeHandler}
                showMonthDropdown
                showYearDropdown
                dropdownMode='select'
                readOnly={false}
              />
            </div>
          </div>
          <div className='center-search-button'>
            <div className='fs-advanced-search-button'>
              <FSFlatButton
                label='Search'
                type='submit'
                style={FSFlatButton.style({ width: '200px' })}
                onClick={() => this.reportButtonPress('Search')}
                primary
              />
            </div>
          </div>
        </section>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HistoricalFlightStatus/components/HistoricalSearch/children/HistoricalByAirportSearch.js